module.exports = __webpack_public_path__ + "static/media/login-bg.d8f3db26.jpg";